import transform from '@/services/devisCommandes/filters/devisCommandeServerTableDataTransformer';
import HTTP from '../HTTP';

const URL_BASE = 'gescom/Devis/';

export async function get(idDevisCommande) {
  const response = await HTTP.get(URL_BASE + 'GetAsync', { params: { id: idDevisCommande } });
  return response;
}

export async function getAll(serverTabledata) {
  const inputServer = transform(serverTabledata);
  const response = await HTTP.post(URL_BASE + 'PGetAllAsync', inputServer);
  return response;
}

export async function create(devisCommande) {
  const response = await HTTP.post(URL_BASE + 'CreateAsync', devisCommande);
  return response;
}

export async function updateAll(devisCommande) {
  const response = await HTTP.put(URL_BASE + 'UpdateAllAsync', devisCommande);
  return response;
}

export async function update(devisCommande) {
  const response = await HTTP.put(URL_BASE + 'UpdateAsync', devisCommande);
  return response;
}

export async function remove(idDevisCommande) {
  const response = await HTTP.delete(URL_BASE + 'DeleteAsync', { params: { id: idDevisCommande } });
  return response;
}

export async function generationFactureAcompte(param) {
  const response = await HTTP.post(URL_BASE + 'GenerationFactureAcompteAsync', param);
  return response;
}

export async function sansSuite(id) {
  const response = await HTTP.post(URL_BASE + 'SansSuiteAsync', { id: id });
  return response;
}

export async function simulationEtatObtenu(params) {
  const response = await HTTP.post(URL_BASE + 'SimulationEtatObtenuASync', params);
  return response;
}

export async function echeancierGeneration(echeancier, montant, tiers) {
  const response = await HTTP.post(URL_BASE + 'PEcheancierGeneration', { echeancier, montant, tiers });
  return response;
}
